import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input } from "@angular/core";
import { ɵMonthTableComponent as MonthTableComponent } from "ng-zorro-antd/date-picker";
import { localize } from "@gtmhub/localization";
import { UiDateHelperService } from "@webapp/ui/date-picker/services/date-helper.service";
import { UiDatePickerService } from "../../services/date-picker.service";
import { UiAriaLabelMonths } from "./../../date-picker.models";

@Component({
  selector: "ui-month-table",
  exportAs: "uiMonthTable",
  templateUrl: "../date-table/date-table.component.html",
  styleUrls: ["month-table.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ui-date-table",
  },
})
export class UiMonthTableComponent extends MonthTableComponent implements AfterViewInit {
  /** the id of the element holding month and year buttons and used to label the table */
  @Input()
  public uiTableLabelledBy: string;

  constructor(public datePickerService: UiDatePickerService, public elementRef: ElementRef<HTMLElement>, dateHelper: UiDateHelperService) {
    super(dateHelper);
  }

  public ngAfterViewInit(): void {
    const monthInnerCells = this.elementRef.nativeElement.getElementsByClassName("ant-picker-cell-inner");

    for (const element of monthInnerCells) {
      const ariaInput: string = localize(UiAriaLabelMonths[element.textContent.trim()]);
      element.setAttribute("aria-label", ariaInput);
    }
  }
}
